import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";

/**
 * Service to increment and fetch page visit count
 * @param url The current page path (e.g., '/', '/about', '/sou-tickets/statue-of-unity-day-package')
 * @returns Latest count for the given URL
 */
export const findAnalyticsCount = async (url: string) => {
  try {
    const response = await axiosApiInstance.post(
      `${API_PORTAL_URL}/Website/FindAnalyticsCount`,
      { URL: url },
    );
    return response.data?.Data;
  } catch (error) {
    console.error("Error updating analytics count:", error);
    return null;
  }
};
